var l23 = {
    code: 'es',
    week: {
        dow: 0,
        doy: 6, // The week that contains Jan 1st is the first week of the year.
    },
    buttonText: {
        prev: 'Ant',
        next: 'Sig',
        today: 'Hoy',
        year: 'Año',
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
        list: 'Agenda',
    },
    weekText: 'Sm',
    allDayText: 'Todo el día',
    moreLinkText: 'más',
    noEventsText: 'No hay eventos para mostrar',
};

export { l23 as default };
